import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSidebarStore = defineStore('sidebar', () => {
    const open = ref(false);

    const toggleSidebar = (state) => {
        open.value = state;
    };

    return {
        open,
        toggleSidebar,
    };
});
